import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServerUrlService } from './server-url.service';
import { ConvenioParametrosType } from '../interfaces/convenio-parametros';
import { ParametrosService } from './parametros.service';

interface ConvenioParametro {
  parametroObrigarCarteirinhaAnexo?: boolean
  parametroObrigarCarteirinhaValidade?: boolean
  parametroValidarCarteirinhaValidade?: boolean
}

@Injectable({
  providedIn: 'root'
})
export class ConveniosService {

  convenioServicos: any = [];
  parametros: ConvenioParametrosType[] = [];
  anexoCarteirinha: File | undefined
  validadeCarteirinha: string = ''
  convenioParametros: ConvenioParametro | undefined

  constructor(
    private http: HttpClient,
    private serverUrlService: ServerUrlService,
    private parametrosService: ParametrosService
  ) {
    this.loadConvenioParametros()
   }

  consultaConvenios() {
    this.http.get(`${this.serverUrlService.getUrl()}/convenios/servicos`)
    .subscribe(
      (data) => {
        this.convenioServicos = data;
      }
    );

    return this.http.get(`${this.serverUrlService.getUrl()}/convenios`);
  }

  getConveniosServicos() {
    return this.convenioServicos;
  }

  checkPagamentoCaixa(convenio: number): boolean {
    let pagCaixa = false
    const convfind = this.convenioServicos.find(conv => conv.convenio_id == convenio );
    if (convfind && convfind.webpagcaixa) {
      pagCaixa = true;
    }
    return pagCaixa;
  }

  loadConvenioParametros(): void {
    this.http.get(`${this.serverUrlService.getUrl()}/convenios/parametros`)
    .subscribe(
      (data) => {
        this.parametros = data as ConvenioParametrosType[];
      }
    );
  }

  findConvenioParametros(convenioId: number, plano: string): ConvenioParametrosType {
    if (plano) {
      return this.parametros.find(item => item.ParametroConvenioID === convenioId && item.ParametroPlano === plano)
    } else {
      return this.parametros.find(item => item.ParametroConvenioID === convenioId )
    }
  }

  checkEloCPF(cpf: string): any {
    const server = this.parametrosService.getNodeParams('REC_NODE_SERVER')
    return this.http.get(`${server}/integracao/eloclinica/associados/listar/${cpf}`);
  }
}
